module.exports = __webpack_public_path__ + "static/media/coaching-crowd.e8261f18.png";